import { motion } from "framer-motion";
import { FiTruck, FiClock, FiGlobe, FiMapPin } from "react-icons/fi";

const shippingZones = [
  {
    zone: "Greater Accra Region",
    time: "1-2 business days",
    cost: "₵20",
    note: "Free shipping on orders over ₵200",
  },
  {
    zone: "Other Regions",
    time: "2-4 business days",
    cost: "₵30-50",
    note: "Cost varies by location",
  },
  {
    zone: "West Africa",
    time: "5-7 business days",
    cost: "Calculated at checkout",
    note: "Customs fees may apply",
  },
  {
    zone: "International",
    time: "10-14 business days",
    cost: "Calculated at checkout",
    note: "Import duties not included",
  },
];

export default function ShippingPolicy() {
  const shippingInfo = [
    {
      title: "Domestic Shipping",
      icon: FiTruck,
      details: [
        "Standard Delivery (2-4 business days)",
        "Express Delivery (1-2 business days)",
        "Free shipping on orders over GHS 200",
      ],
    },
    {
      title: "Processing Time",
      icon: FiClock,
      details: [
        "Orders processed within 24 hours",
        "Same-day dispatch for orders before 12 PM",
        "Order confirmation email with tracking",
      ],
    },
    {
      title: "International Shipping",
      icon: FiGlobe,
      details: [
        "Available to select countries",
        "Delivery time: 7-14 business days",
        "Customs fees may apply",
      ],
    },
  ];

  return (
    <div className="bg-gray-50 pt-24">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-12"
        >
          <span className="inline-block px-4 py-1.5 mb-4 text-sm font-medium tracking-wider text-[#DB5461] bg-[#DB5461]/10 rounded-full">
            SHIPPING POLICY
          </span>
          <h1 className="text-4xl font-serif font-bold text-[#DB5461] mb-4">
            Shipping Policy
          </h1>
          <div className="w-24 h-1 bg-[#DB5461] mx-auto rounded-full mb-6" />
          <p className="text-lg text-gray-600">
            Learn about our shipping methods and delivery times
          </p>
        </motion.div>

        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {shippingInfo.map((section, index) => {
            const Icon = section.icon;
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                className="bg-white p-6 rounded-lg shadow-md"
              >
                <div className="flex items-center mb-4">
                  <div className="p-3 bg-[#DB5461]/10 rounded-full">
                    <Icon className="h-6 w-6 text-[#DB5461]" />
                  </div>
                  <h2 className="ml-3 text-xl font-semibold text-gray-900">
                    {section.title}
                  </h2>
                </div>
                <ul className="space-y-3 text-gray-600">
                  {section.details.map((detail, idx) => (
                    <li key={idx} className="flex items-start">
                      <span className="h-6 w-6 text-[#DB5461] mr-2">•</span>
                      {detail}
                    </li>
                  ))}
                </ul>
              </motion.div>
            );
          })}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
          className="mt-12 bg-white p-6 rounded-lg shadow-md"
        >
          <h2 className="text-2xl font-semibold text-[#DB5461] mb-4">
            Important Information
          </h2>
          <div className="space-y-4 text-gray-600">
            <p>
              • Tracking information will be provided via email once your order
              ships.
            </p>
            <p>• Delivery times may vary during peak seasons and holidays.</p>
            <p>
              • For international orders, please note that customs fees are the
              responsibility of the recipient.
            </p>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
          className="mt-8 text-center"
        >
          <p className="text-gray-600">
            Have questions about shipping?{" "}
            <a
              href="/contact"
              className="text-[#DB5461] hover:text-[#DB5461]/80"
            >
              Contact us
            </a>
          </p>
        </motion.div>
      </div>
    </div>
  );
}
